import { useContextState } from '../../../../../../hooks/theme'

function useStyles() {
  const { colors } = useContextState()
  return {
    text: {
      fontSize: '16px',
      fontWeight: '400',
      color: colors.color20,
      lineHeight: 1.6,
      wordBreak: 'break-word',
    },
  }
}

export { useStyles }
